<template>
  <section>
    <div class="row">
      <label for="showTimer">Timer</label>
      <input type="checkbox" id="showTimer" v-model="showTimer">
    </div>
    <div class="row">
      <label for="showThankYou">Thank You</label>
      <input type="checkbox" id="showThankYou" v-model="showThankYou">
    </div>
    <div class="row">
      <label for="showResults">Results</label>
      <input type="checkbox" id="showResults" v-model="showResults">
    </div>
    <div class="row">
      <label for="makeHorizontal">Horizontal</label>
      <input type="checkbox" id="makeHorizontal" v-model="makeHorizontal">
    </div>
    <div class="row">
      <label for="showAnimatedBackground">Animated Background</label>
      <input type="checkbox" id="showAnimatedBackground" v-model="showAnimatedBackground">
    </div>
    <div class="row">
      <label for="showMultiVote">Multi-Vote</label>
      <input type="checkbox" id="showMultiVote" v-model="showMultiVote">
    </div>
    <div class="row">
      <label for="cornerStyle">Corner Style</label>
      <div class="select">
        <select v-model="cornerStyle">
          <option v-for="option in ['round', 'square']" :key="option" v-bind:value="option">
            {{ option }}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <label for="cornerStyle">Font Family</label>
      <div class="select">
        <select v-model="fontId">
          <option v-for="option in fontOptions" :key="option.id" v-bind:value="option.id">
            {{ option.id }} ({{ option.provider }})
          </option>
        </select>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Admin',
  props: {
  },
  data() {
    return {
      fontOptions: [{
        provider: 'google',
        id: 'Roboto'
      }, {
        provider: 'google',
        id: 'Lexend Peta'
      }, {
        provider: 'google',
        id: 'Open Sans'
      }, {
        provider: 'google',
        id: 'Alata',
      }, {
        provider: 'google',
        id: 'Noto Sans JP'
      }, {
        provider: 'google',
        id: 'Montserrat'
      }, {
        provider: 'google',
        id: 'Gayathri'
      }, {
        provider: 'google',
        id: 'Roboto Condensed'
      }, {
        provider: 'google',
        id: 'Lato'
      }, {
        provider: 'google',
        id: 'Oswald'
      }, {
        provider: 'google',
        id: 'Krona One'
      }]
    }
  },
  computed: {
    showTimer: {
      get() {
        return this.$store.state.showTimer;
      },
      set() {
        this.toggleSetting('showTimer');
      }
    },
    showThankYou: {
      get() {
        return this.$store.state.showThankYou;
      },
      set() {
        this.toggleSetting('showThankYou');
      }
    },
    showResults: {
      get() {
        return this.$store.state.showResults;
      },
      set() {
        this.toggleSetting('showResults');
      }
    },
    makeHorizontal: {
      get() {
        return this.$store.state.isHorizontal;
      },
      set() {
        this.toggleSetting('isHorizontal');
      }
    },
    showAnimatedBackground: {
      get() {
        return this.$store.state.showAnimatedBackground;
      },
      set() {
        this.toggleSetting('showAnimatedBackground');
      }
    },
    showMultiVote: {
      get() {
        return this.$store.state.showMultiVote;
      },
      set() {
        this.toggleSetting('showMultiVote');
      }
    },
    cornerStyle: {
      get() {
        return this.$store.state.cornerStyle;
      },
      set(newValue) {
        this.setCornerStyle(newValue);
      }
    },
    fontId: {
      get() {
        return this.$store.state.fontId;
      },
      set(newValue) {
        this.loadFont({
          id: newValue,
          provider: 'google'
        });
      }
    },
  },
  methods: {
    ...mapActions('poll', [
      'toggleSetting',
      'setCornerStyle',
      'loadFont'
    ])
  }
}
</script>

<style scoped lang="scss">
section {
  position: fixed;
  top: 0;
  left: 0;
  width: 200px;
  padding: 16px;
  border-radius: 0 0 12px 0;
  background: rgba(0,0,0,0.5);
  z-index: 106;
  font-family: Arial, Helvetica, sans-serif;
}

.row {
  display: flex;
  width: 100%;
  margin: 2px 0 0 0;
  border-bottom: 1px solid rgba(0,0,0,0.2);
}

label {
  flex: 1 1 auto;
  font-size: 12px;
  margin: 2px 5px 2px 0;
  white-space: nowrap;
  cursor: pointer;
}

input,
.select {
  flex: 0 0 auto;
  display: inline-block;
  margin: 0;
  font-size: 12px;
  max-width: 100px;
}

select {
  display: inline-block;
  margin: 0;
  font-size: 12px;
  max-width: 100px;
}

input {
  margin: -1px 0 0 0;
}
</style>
